module.exports = __webpack_public_path__ + "static/media/food_bag.cd0cdaff.svg";